// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1QHKc","top":"styles_top__1-cBo"};